import { Link } from "react-router-dom";
import { Sparkles, Mail, Phone, MapPin, Instagram, Facebook } from "lucide-react";

const Footer = () => {
  return (
    <footer className="bg-mystic-deep border-t border-white/10 stars-bg" data-testid="footer">
      <div className="max-w-7xl mx-auto px-6 md:px-12 lg:px-24 py-16">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12">
          {/* Brand */}
          <div className="space-y-4">
            <div className="flex items-center gap-2">
              <img 
                src="https://customer-assets.emergentagent.com/job_crystal-haven-2/artifacts/y9uaa7nd_FullLogo_Transparent.png" 
                alt="Krystalz" 
                className="h-36 w-auto brightness-125 contrast-110"
              />
            </div>
            <p className="text-mystic-mist/80 text-sm leading-relaxed">
              Channeling the mystical energy of crystals to seekers across India. 
              Unlock your spiritual potential.
            </p>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="font-serif text-lg font-medium mb-4 text-mystic-orchid">Quick Links</h4>
            <ul className="space-y-3">
              <li>
                <Link 
                  to="/products" 
                  className="text-mystic-mist/80 hover:text-mystic-amethyst transition-colors text-sm"
                  data-testid="footer-link-shop"
                >
                  Shop All
                </Link>
              </li>
              <li>
                <Link 
                  to="/products?category=healing" 
                  className="text-mystic-mist/80 hover:text-mystic-amethyst transition-colors text-sm"
                  data-testid="footer-link-healing"
                >
                  Healing Crystals
                </Link>
              </li>
              <li>
                <Link 
                  to="/products?category=raw" 
                  className="text-mystic-mist/80 hover:text-mystic-amethyst transition-colors text-sm"
                  data-testid="footer-link-raw"
                >
                  Raw Stones
                </Link>
              </li>
              <li>
                <Link 
                  to="/contact" 
                  className="text-mystic-mist/80 hover:text-mystic-amethyst transition-colors text-sm"
                  data-testid="footer-link-contact"
                >
                  Contact Us
                </Link>
              </li>
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h4 className="font-serif text-lg font-medium mb-4 text-mystic-orchid">Contact</h4>
            <ul className="space-y-3">
              <li className="flex items-center gap-3 text-sm text-mystic-mist/80">
                <Mail className="w-4 h-4 text-mystic-amethyst" />
                hello@krystalz.in
              </li>
              <li className="flex items-center gap-3 text-sm text-mystic-mist/80">
                <Phone className="w-4 h-4 text-mystic-amethyst" />
                +91 9030792052
              </li>
              <li className="flex items-start gap-3 text-sm text-mystic-mist/80">
                <MapPin className="w-4 h-4 text-mystic-amethyst mt-0.5" />
                <span>Hyderabad, Telangana, India</span>
              </li>
            </ul>
          </div>

          {/* Social */}
          <div>
            <h4 className="font-serif text-lg font-medium mb-4 text-mystic-orchid">Follow Us</h4>
            <div className="flex gap-4">
              <a 
                href="#" 
                className="w-10 h-10 rounded-full bg-white/5 border border-white/10 flex items-center justify-center hover:bg-mystic-amethyst hover:border-mystic-amethyst transition-all neon-glow-hover"
                data-testid="social-instagram"
              >
                <Instagram className="w-5 h-5 text-mystic-silver" />
              </a>
              <a 
                href="#" 
                className="w-10 h-10 rounded-full bg-white/5 border border-white/10 flex items-center justify-center hover:bg-mystic-amethyst hover:border-mystic-amethyst transition-all neon-glow-hover"
                data-testid="social-facebook"
              >
                <Facebook className="w-5 h-5 text-mystic-silver" />
              </a>
            </div>
            <p className="mt-6 text-xs text-mystic-mist/60">
              Shipping cosmic energy to all pincodes across India
            </p>
          </div>
        </div>

        <div className="mt-12 pt-8 border-t border-white/10 flex flex-col md:flex-row justify-between items-center gap-4">
          <p className="text-xs text-mystic-mist/60">
            © 2024 Krystalz. All rights reserved.
          </p>
          <p className="text-xs text-mystic-mist/60">
            ✨ Crafted with mystical energy ✨
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
